if (typeof ProductPage !== 'function') {

	class ProductPage extends HTMLElement {

		constructor() {

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			this.pickupAvailabilityCompact = this.querySelector('pickup-availability-compact');
			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			// Gallery thumbnails

			if (this.productSlider) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if (this.querySelector('.product-gallery__thumbnails .thumbnail')) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i) => {
						if (i == 0) {
							elm.classList.add('active');
						}
						elm.addEventListener('click', e => {
							if (this.productSlider.sliderEnabled) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							this._pauseAllMedia();
							this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e => {
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('navigation', e => {
					this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`));
				})
				this.productSlider.addEventListener('change', e => {
					this._pauseAllMedia();
					if (this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model') {
						if (this.xrButton) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(() => {
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e) => {

					if (this.firstProductGalleryIndex) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}

					const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
					const productFigures = this.querySelectorAll('.apply-gallery-animation');
					this.productSlider.addEventListener('scroll', () => {
						const scrollX = -this.productSlider.element.scrollLeft;
						productSlides.forEach((slide, i) => {
							const media = productFigures[i];
							if (media) {
								media.style.transform = `translateX(${(slide.offsetLeft + scrollX) * -1 / 3}px)`;
							}
						});
					});

				});

			}

			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants');
			if (this.productVariants) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({ target: this.productVariants });
			}

			// show cart drawer when element is added to cart

			if (!document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay') {

				let addToCartEnter = false;
				if (this.querySelector('[data-js-product-add-to-cart]')) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e => {
						if (e.keyCode == window.KEYCODES.RETURN) {
							addToCartEnter = true;
						}
					})
				}

				if (this.querySelector('[data-js-product-form]')) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', () => {
						if (this.cartType == 'page') {
							this.notifyItemAddedToCart();
						}
						else {
							document.getElementById('site-cart-sidebar').show();
						}

						if (document.getElementById('cart-recommendations')) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if (addToCartEnter) {
							setTimeout(() => {
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if (models.length > 0) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if (addToCartButton) {
				if (addToCartButton.classList.contains('disabled')) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(() => {
					if (addToCartButton.classList.contains('disabled')) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton, { attributes: true, childList: false, subtree: false });
			}

			// update secondary price if present

			this.priceCompact = this.querySelector('[data-js-product-price-compact');
			this.priceExtended = this.querySelector('[data-js-product-price-extended');

			if (this.priceCompact) {
				this.priceCompact.priceOriginal = this.priceCompact.querySelector('[data-js-product-price-original]');
				this.priceCompact.priceCompare = this.priceCompact.querySelector('[data-js-product-price-compare]');
				this.priceCompact.priceUnit = this.priceCompact.querySelector('[data-js-product-price-unit]');
			}
			if (this.priceExtended) {
				this.priceExtended.priceOriginal = this.priceExtended.querySelector('[data-js-product-price-original]');
				this.priceExtended.priceCompare = this.priceExtended.querySelector('[data-js-product-price-compare]');
				this.priceExtended.priceUnit = this.priceExtended.querySelector('[data-js-product-price-unit]');
			}

			//
			this.addIdToRecentlyViewed();
		}

		notifyItemAddedToCart() {
			document.querySelector(".sticky-header").classList.add("show");
			// Use querySelectorAll because there are cart button on desktop + mobile
			var itemAddedToCartTooltip = document.querySelectorAll(".item-added-to-cart");
			if(itemAddedToCartTooltip.length !== 0) {
				itemAddedToCartTooltip.forEach(elem => {
					elem.classList.add('show');
					setTimeout(function() {
						elem.classList.remove('show');
					}, 3000);
				});
				return;
			}
			
			const childrenNode = `
			<svg class="icon-polygon" xmlns="http://www.w3.org/2000/svg" width="27" height="24" viewBox="0 0 27 24" fill="none">
			<path d="M13.3867 0.706787L26.3771 23.2068H0.396338L13.3867 0.706787Z" fill="white"/>
			</svg>
			<svg xmlns="http://www.w3.org/2000/svg" width="30" height="38" viewBox="0 0 30 38" fill="none">
			<path d="M4.23368 14.1121C4.00746 14.1121 3.78596 13.998 3.65833 13.7907C3.2437 13.1188 2.46914 12.3415 1.57979 12.3699C1.20162 12.3496 0.895042 12.0876 0.884237 11.7155C0.872757 11.3421 1.16583 11.0308 1.53859 11.0193C2.96143 10.9767 4.17493 12.0552 4.80768 13.0823C5.00351 13.3997 4.90492 13.8157 4.58753 14.0115C4.47746 14.0797 4.35456 14.1121 4.23368 14.1121Z" fill="#436B1C"/>
			<path d="M18.0548 5.1199C17.9643 3.80443 16.871 2.76448 15.5326 2.76448C15.5286 2.76448 15.5252 2.76516 15.5211 2.76516C15.5448 2.56595 15.5313 2.35526 15.4671 2.13579C15.2861 1.51857 14.7432 1.04452 14.1044 0.96821C13.5804 0.906083 13.0995 1.09381 12.7626 1.42673C12.4418 1.13703 12.0218 0.956055 11.5558 0.956055C10.5571 0.956055 9.74808 1.76573 9.74808 2.76381C9.74808 2.76718 9.74876 2.76989 9.74876 2.77326C8.53526 2.8651 7.57837 3.87736 7.57837 5.11449C7.57837 5.30358 7.60336 5.48658 7.64522 5.66283C6.20078 5.72293 5.04738 6.91009 5.04738 8.3694C5.04738 8.86371 5.18176 9.32561 5.41271 9.7247C4.96905 10.0894 4.68542 10.6424 4.68542 11.2617C4.68542 11.8276 4.92515 12.3347 5.30467 12.696C6.93347 11.365 8.64465 15.8165 10.6597 19.3706C11.3289 20.551 18.5593 19.2936 19.1353 20.0269C19.7917 19.4367 20.2158 9.15881 20.234 8.25595C20.2624 6.80745 19.3426 5.57167 18.0548 5.1199Z" fill="#88C057"/>
			<path d="M18.9794 18.5825L19.4609 18.2942C20.3522 17.7593 21.4651 17.7593 22.3558 18.2942L22.8373 18.5825C23.7287 19.1174 24.8416 19.1174 25.7323 18.5825L27.093 17.9775C27.2929 17.4197 27.432 17.0159 27.4874 16.8369C28.7569 12.7534 29.5747 8.45384 29.6861 4.16507C29.7307 2.44038 28.3045 -0.249303 25.9349 0.972973C23.6058 2.17364 21.9378 6.77845 20.7655 8.96504C19.1003 12.0721 17.7834 15.4512 16.8455 18.8945C17.5599 19.0748 18.3284 18.9728 18.9794 18.5825Z" fill="#EEAF4B"/>
			<path d="M1.42307 17.8889L2.33134 18.4339C3.37466 19.0598 4.67797 19.0598 5.7213 18.4339L5.95495 18.2934C6.84633 17.7586 7.95921 17.7586 8.84992 18.2934L9.3314 18.5817C9.85475 18.8958 10.4544 19.02 11.0406 18.9653C11.4727 17.5695 11.3276 15.8245 10.6577 14.6434C8.4049 10.6694 6.53097 11.479 4.72794 13.2044C4.3822 13.5353 3.95946 13.7777 3.49891 13.9094C1.52166 14.4746 0.0623603 15.3991 0.892293 17.9166C1.03883 17.8099 1.24277 17.7808 1.42307 17.8889Z" fill="#ED3F32"/>
			<path d="M20.6938 17.1124C20.6222 17.1124 20.5486 17.1009 20.477 17.0766C20.1239 16.9564 19.9348 16.5728 20.055 16.2197C20.5054 14.8947 21.9519 14.1857 23.2748 14.6314C23.8954 14.8427 24.5713 14.5091 24.782 13.8885C24.9015 13.5354 25.2838 13.3449 25.639 13.4658C25.9921 13.586 26.1812 13.9696 26.061 14.3228C25.6113 15.6484 24.1662 16.3601 22.8412 15.911C22.2213 15.7004 21.5453 16.0346 21.334 16.6539C21.2374 16.9361 20.9747 17.1124 20.6938 17.1124Z" fill="#A46F3E"/>
			<path d="M22.291 12.4076C22.2194 12.4076 22.1458 12.3961 22.0742 12.3718C21.721 12.2516 21.5319 11.868 21.6521 11.5148C21.8703 10.8726 22.3254 10.3533 22.9332 10.0535C23.5409 9.75367 24.2291 9.70842 24.8719 9.92654C25.4939 10.1386 26.1685 9.80432 26.3792 9.18305C26.4987 8.8292 26.8823 8.63944 27.2355 8.76032C27.5886 8.88052 27.7777 9.26408 27.6575 9.61726C27.2078 10.9435 25.7626 11.6539 24.4377 11.2062C24.1372 11.1036 23.8144 11.1245 23.5301 11.265C23.2458 11.4054 23.0331 11.6479 22.9305 11.949C22.8353 12.2306 22.5726 12.4076 22.291 12.4076Z" fill="#A46F3E"/>
			<path d="M23.8887 7.70222C23.8171 7.70222 23.7435 7.69074 23.6713 7.66643C23.3181 7.54622 23.129 7.16266 23.2492 6.80948C23.6436 5.64663 24.9124 5.02266 26.0753 5.41568C26.2981 5.49131 26.5358 5.47646 26.7459 5.37314C26.9559 5.26982 27.1132 5.09019 27.1888 4.86802C27.3084 4.51484 27.6913 4.32509 28.0458 4.44529C28.399 4.56549 28.588 4.94906 28.4678 5.30223C28.2761 5.8661 27.877 6.32192 27.3435 6.58461C26.8093 6.84797 26.2049 6.88647 25.6411 6.69536C25.1832 6.53937 24.6835 6.78585 24.5282 7.24437C24.4323 7.52529 24.1696 7.70222 23.8887 7.70222Z" fill="#A46F3E"/>
			<path d="M12.4405 10.1832C11.8023 11.0321 10.7955 12.0369 11.1831 13.8116L12.2258 18.5825L12.7079 18.2942C13.5993 17.7593 14.7122 17.7593 15.6029 18.2942L16.0844 18.5825C16.476 18.8175 16.8454 18.8952 16.8454 18.8952C17.5491 16.3135 18.4654 13.7677 19.5817 11.3461C19.059 10.0387 17.9428 9.60114 17.1324 9.15342C17.1277 9.15072 17.123 9.14802 17.1189 9.14599C16.6064 8.85224 16.5746 8.15061 16.9602 7.70357C17.1122 7.52732 17.1824 7.28489 17.1297 7.04178L17.048 6.66902C16.9582 6.25845 16.549 5.99643 16.1391 6.08625L12.0353 6.98168C11.6247 7.0715 11.3627 7.48072 11.4525 7.89062L11.5343 8.26338C11.5883 8.51189 11.7598 8.70435 11.9772 8.79821C12.4763 9.01363 12.7808 9.57075 12.5256 10.0509C12.5013 10.0961 12.4729 10.14 12.4405 10.1832Z" fill="#DAE7EF"/>
			<path d="M16.7461 8.02511L12.1008 9.04008C11.5883 9.15217 11.0764 8.82398 10.9643 8.31144L10.8975 8.00621C10.7854 7.49366 11.1135 6.98179 11.6261 6.86969L16.2714 5.85473C16.784 5.74263 17.2958 6.07082 17.4079 6.58337L17.4748 6.8886C17.5869 7.40182 17.2587 7.91302 16.7461 8.02511Z" fill="white"/>
			<path d="M28.2733 17.7714L27.095 34.6733C27.0085 36.3608 25.6154 37.6844 23.9258 37.6844H4.96973C3.28015 37.6844 1.88703 36.3608 1.80059 34.6733L0.650568 18.3258C0.630984 17.9416 1.04764 17.6911 1.37786 17.8889L2.28612 18.4339C3.32945 19.0599 4.63276 19.0599 5.67608 18.4339L5.90973 18.2934C6.80112 17.7586 7.914 17.7586 8.8047 18.2934L9.28619 18.5825C10.1776 19.1173 11.2904 19.1173 12.1812 18.5825L12.6626 18.2934C13.554 17.7586 14.6669 17.7586 15.5576 18.2934L16.0391 18.5825C16.9305 19.1173 18.0434 19.1173 18.9341 18.5825L19.4155 18.2934C20.3069 17.7586 21.4198 17.7586 22.3105 18.2934L22.792 18.5825C23.6834 19.1173 24.7963 19.1173 25.687 18.5825L27.9742 17.5661C28.1194 17.5013 28.2814 17.6127 28.2733 17.7714Z" fill="#FBD490"/>
			<path d="M8.7534 29.0273H4.02636C3.6536 29.0273 3.35107 28.7255 3.35107 28.352C3.35107 27.9786 3.6536 27.6768 4.02636 27.6768H8.7534C9.12616 27.6768 9.42869 27.9786 9.42869 28.352C9.42869 28.7255 9.12616 29.0273 8.7534 29.0273Z" fill="#E0B877"/>
			<path d="M10.104 31.7285H4.02636C3.6536 31.7285 3.35107 31.4267 3.35107 31.0532C3.35107 30.6798 3.6536 30.3779 4.02636 30.3779H10.104C10.4767 30.3779 10.7793 30.6798 10.7793 31.0532C10.7793 31.4267 10.4767 31.7285 10.104 31.7285Z" fill="#E0B877"/>
			<path d="M11.4546 34.4297H4.02636C3.6536 34.4297 3.35107 34.1278 3.35107 33.7544C3.35107 33.381 3.6536 33.0791 4.02636 33.0791H11.4546C11.8273 33.0791 12.1299 33.381 12.1299 33.7544C12.1299 34.1278 11.8273 34.4297 11.4546 34.4297Z" fill="#E0B877"/>
			<path d="M15.5063 34.4297H14.1558C13.783 34.4297 13.4805 34.1278 13.4805 33.7544C13.4805 33.381 13.783 33.0791 14.1558 33.0791H15.5063C15.8791 33.0791 16.1816 33.381 16.1816 33.7544C16.1816 34.1278 15.8791 34.4297 15.5063 34.4297Z" fill="#E0B877"/>
			</svg> 
			<div> Item Added To Your Cart </div>`;

			document.querySelectorAll(".sticky-header .cart-button").forEach(elem => {
				itemAddedToCartTooltip = document.createElement("div");
				itemAddedToCartTooltip.classList.add('item-added-to-cart', 'show');
				itemAddedToCartTooltip.innerHTML = childrenNode;

				elem.append(itemAddedToCartTooltip);
			})

			document.querySelectorAll(".item-added-to-cart").forEach(elem => {
				setTimeout(function() {
					elem.classList.remove('show');
				}, 3000);
			});
		}

		addIdToRecentlyViewed() {
			const { id, handle, imageUrl } = this.dataset;
			if (!handle) return;

			// Remove current product if already in set of recent
			if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
				delete theme.recentlyViewed.recent[handle];
			}

			// Add it back to the end
			theme.recentlyViewed.recent[handle] = {
				id,
				handle,
				url: imageUrl
			};

			window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
		}

		thumbnailNavigationHelper(index = 0) {
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i) => {
				if (i == index)
					elm.classList.add('active');
				else
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e) {

			let variant = e.target.currentVariant;
			if (variant) {

				// image handling

				if (variant.featured_media != null) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if (variantImg) {
						if (this.productGallery.classList.contains('product-gallery--slider') || (this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024)) {
							if (this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}

				// refresh pickup availability widgets

				if (this.pickupAvailabilityCompact && this.pickupAvailabilityCompact.classList.contains('active')) {
					this.querySelector('pickup-availability-compact').style.display = 'block';
					this.querySelector('pickup-availability-compact').fetchAvailability(variant.id);
				}

				if (this.pickupAvailabilityExtended && this.pickupAvailabilityExtended.classList.contains('active')) {
					this.querySelector('pickup-availability-extended').style.display = 'block';
					this.querySelector('pickup-availability-extended').fetchAvailability(variant.id);
				}

			} else {

				if (this.pickupAvailabilityCompact && this.pickupAvailabilityCompact.classList.contains('active')) {
					this.querySelector('pickup-availability-compact').style.display = 'none';
				}

				if (this.pickupAvailabilityExtended && this.pickupAvailabilityExtended.classList.contains('active')) {
					this.querySelector('pickup-availability-extended').style.display = 'none';
				}

			}

			// update prices (overwrites the framework)

			if (this.priceCompact) {
				if (!variant) {
					this.priceCompact.priceOriginal.innerHTML = '';
					this.priceCompact.priceCompare.innerHTML = '';
					this.priceCompact.priceUnit.innerHTML = '';
				} else {
					this.priceCompact.priceOriginal.innerHTML = this.productVariants._formatMoney(variant.price, KROWN.settings.shop_money_format);
					if (variant.compare_at_price > variant.price) {
						this.priceCompact.priceCompare.innerHTML = this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format);
						//this.priceCompact.priceCompare.innerHTML = `<span>${this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format)}</span><span class="product-item__badge">-${Math.round(Math.abs((variant.price * 100 / variant.compare_at_price) - 100))}%</span>`;
					} else {
						this.priceCompact.priceCompare.innerHTML = '';
					}

					if (variant.unit_price_measurement) {
						this.priceCompact.priceUnit.innerHTML = `
							${this.productVariants._formatMoney(variant.unit_price, KROWN.settings.shop_money_format)} /
							${(variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value + ' ' : '')}
							${variant.unit_price_measurement.reference_unit}
						`;
					} else {
						this.priceCompact.priceUnit.innerHTML = '';
					}
				}
			}

			if (this.priceExtended) {
				if (!variant) {
					this.priceExtended.priceOriginal.innerHTML = '';
					this.priceExtended.priceCompare.innerHTML = '';
					this.priceExtended.priceUnit.innerHTML = '';
				} else {
					this.priceExtended.priceOriginal.innerHTML = this.productVariants._formatMoney(variant.price, KROWN.settings.shop_money_format);
					if (variant.compare_at_price > variant.price) {
						this.priceExtended.priceCompare.innerHTML = `<span>${this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format)}</span><span>${KROWN.settings.locales.product_compare_price.replace('$SAVE_PRICE', this.productVariants._formatMoney(variant.compare_at_price - variant.price, KROWN.settings.shop_money_format))}</span>`;
					} else {
						this.priceExtended.priceCompare.innerHTML = '';
					}

					if (variant.unit_price_measurement) {
						this.priceExtended.priceUnit.innerHTML = `
							${this.productVariants._formatMoney(variant.unit_price, KROWN.settings.shop_money_format)} /
							${(variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value + ' ' : '')}
							${variant.unit_price_measurement.reference_unit}
						`;
					} else {
						this.priceExtended.priceUnit.innerHTML = '';
					}
				}
			}

			// Updates MOQ text if metafield exists
			if (variant.metafields.custom.minimum_quantity) {
				const moqVariant = variant.metafields.custom.minimum_quantity;
				if(document.querySelector('.product-moq')) {
					document.querySelector('.product-moq').innerText = `Quantity - (MOQ ${moqVariant})`;
				}

				// Re-update product quantity with specific MOQ by current variant
				const inputProductQty = this.querySelector('[name="quantity"]');
				inputProductQty.value = moqVariant;
				inputProductQty.defaultValue = moqVariant;
				inputProductQty.min = moqVariant;
			}
		}

		_pauseAllMedia() {

			document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
			document.querySelectorAll('.product-gallery product-model').forEach(model => {
				if (model.modelViewerUI)
					model.modelViewerUI.pause()
			});
		}

		_playMedia(media) {
			switch (media.dataset.productMediaType) {
				case 'video':
					if (media.querySelector('video')) {
						media.querySelector('video').play();
					}
					break;
				case 'external_video-youtube':
					if (media.querySelector('.js-youtube')) {
						media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}
					break;
				case 'external_video-vimeo':
					if (media.querySelector('.js-vimeo')) {
						media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					}
					break;
			}
		}

	}

	if (typeof customElements.get('product-page') == 'undefined') {
		customElements.define('product-page', ProductPage);
	}

}